export default __webpack_public_path__ + "static/media/new-sub-tier-green.fcd1a8b8.svg";